import { NgModule } from '@angular/core';
import { twoFactorRestClientInjectionToken } from "@zaeper/angular-2fa-lib";
import { TwoFactorRestClient } from "./two-factor/two-factor-rest.client";
import {
  userAuthenticationRestClientInjectionToken
} from "./user/authentication/user-authentication-rest-client-injection-token";
import { UserAuthenticationRestClient } from "./user/authentication/user-authentication-rest.client";
import { appRestClientInjectionToken } from './application/app/app-rest-client-injection-token';
import { AppRestClient } from "./application/app/app-rest.client";
import {
  appVersionRestClientInjectionToken
} from "./application-version/app-version/app-version-rest-client-injection-token";
import { AppVersionRestClient } from "./application-version/app-version/app-version-rest.client";
import {
  developerBillingRestClientInjectionToken
} from "./billing/developer-billing-rest-client-injection-token";
import { DeveloperBillingRestClient } from "./billing/developer-billing-rest.client";
import { launcherRestClientInjectionToken } from "./application/launcher/launcher-rest-client-injection-token";
import { LauncherRestClient } from "./application/launcher/launcher-rest.client";
import { widgetRestClientInjectionToken } from "./application/widget/widget-rest-client-injection-token";
import { WidgetRestClient } from "./application/widget/widget-rest.client";
import {
  launcherVersionRestClientInjectionToken
} from "./application-version/launcher-version/launcher-version-rest-client-injection-token";
import { LauncherVersionRestClient } from "./application-version/launcher-version/launcher-version-rest.client";
import {
  widgetVersionRestClientInjectionToken
} from "./application-version/widget-version/widget-version-rest-client-injection-token";
import { WidgetVersionRestClient } from "./application-version/widget-version/widget-version-rest.client";

@NgModule( {
  providers: [
    {
      provide: appRestClientInjectionToken,
      useClass: AppRestClient
    }, {
      provide: appVersionRestClientInjectionToken,
      useClass: AppVersionRestClient
    }, {
      provide: userAuthenticationRestClientInjectionToken,
      useClass: UserAuthenticationRestClient
    }, {
      provide: developerBillingRestClientInjectionToken,
      useClass: DeveloperBillingRestClient
    }, {
      provide: launcherRestClientInjectionToken,
      useClass: LauncherRestClient
    }, {
      provide: widgetRestClientInjectionToken,
      useClass: WidgetRestClient
    }, {
      provide: launcherVersionRestClientInjectionToken,
      useClass: LauncherVersionRestClient
    }, {
      provide: widgetVersionRestClientInjectionToken,
      useClass: WidgetVersionRestClient
    }, {
      provide: twoFactorRestClientInjectionToken,
      useClass: TwoFactorRestClient
    }
  ]
} )
export class RestClientsModule {
}
